import * as React from 'react';

import Midnight from '@/assets/icons/icon_midnight.svg';
import Morning from '@/assets/icons/icon_morning.svg';
import Nighter from '@/assets/icons/icon_night.svg';
import { TimeFrame } from '@/lib/apollo/types/gen/graphql';

interface TimeFrameProps {
  timeFrame: TimeFrame;
  width?: string;
  height?: string;
}

const TimeFrameIcon: React.FC<TimeFrameProps> = ({
  timeFrame,
  width = '16px',
  height = '16px',
}) => {
  const styles = { width, height };

  switch (timeFrame) {
    case TimeFrame.Morning: {
      return <img src={Morning} style={{ ...styles }} alt="モーニング" />;
    }
    case TimeFrame.Nighter: {
      return <img src={Nighter} style={{ ...styles }} alt="ナイター" />;
    }
    case TimeFrame.Midnight: {
      return <img src={Midnight} style={{ ...styles }} alt="ミッドナイト" />;
    }
    default: {
      return <></>;
    }
  }
};

export default TimeFrameIcon;
